import { isNumber, isString } from "lodash";
import format from "string-template";

export const generateSQLCondition = (ruleName, condition, value) => {
  if (
    (!isNumber(value) && !value) ||
    (isString(value) && value.includes("null"))
  )
    return "1 = 1";
  return format(
    `EXISTS (SELECT 1 FROM public.rule AS r WHERE r."insurancePlanParamsId" = params.id AND r.name = '{ruleName}' AND ({condition})) OR NOT EXISTS (SELECT 1 FROM public.rule AS r WHERE r."insurancePlanParamsId" = params.id AND r.name = '{ruleName}')`,
    { ruleName, condition: condition.replace(":value", value) },
  );
};
